module.exports = __webpack_public_path__ + "static/media/4-xs.91b43a09.jpg";